<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Background Image -->
          <div class="w-full h-full">
            <img
              src="@/../img/home/laptop.png"
              alt="Futuristische stad"
              class="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>

          <!-- Right Side: Content -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2 class="text-4xl md:text-5xl mb-8 pb-2">{{ t("Blijf Ontwikkelen") }}</h2>

            <div class="space-y-8">
              <!-- Step 1 -->
              <div class="relative border-2 p-7 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >1</div>
                <h3 class="text-lg md:text-xl font-semibold">{{ t("Slim algoritme") }}</h3>
                <p>{{ t("Ons systeem selecteert automatisch de best passende professionals voor uw specifieke situatie.") }}</p>
              </div>

              <!-- Step 2 -->
              <div class="relative border-2 p-7 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg semi rounded-md shadow-md border-2 border-white"
                >2</div>
                <h3 class="text-lg md:text-xl font-semibold">{{ t("Gerichte koppeling") }}</h3>
                <p>{{ t("Matching gebeurt op basis van specialisme, beschikbaarheid en locatie voor optimale resultaten.") }}</p>
              </div>

              <!-- Step 3 -->

              <div class="relative border-2 p-7 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >3</div>
                <h3 class="text-lg md:text-xl font-semibold">{{ t("Hoog slagingspercentage") }}</h3>
                <p>{{ t("94% succesvolle matches binnen 48 uur, met persoonlijke ondersteuning van onze consultants.") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>